var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElipse1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 115,
    viewBox: "0 0 229 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M229 114.5C229 99.4636 226.038 84.5745 220.284 70.6827C214.53 56.791 206.096 44.1686 195.464 33.5363C184.831 22.904 172.209 14.47 158.317 8.71579C144.425 2.96163 129.536 -6.5726e-07 114.5 0C99.4636 6.5726e-07 84.5745 2.96163 70.6827 8.7158C56.791 14.47 44.1686 22.904 33.5363 33.5363C22.904 44.1686 14.47 56.791 8.71579 70.6828C2.96163 84.5745 -1.31452e-06 99.4637 0 114.5L114.5 114.5H229Z",
    fill: "#FFBF7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElipse1);
export default __webpack_public_path__ + "static/media/Elipse1.e90b8c0be4bfa2914c5734ae0fa49ac9.svg";
export { ForwardRef as ReactComponent };